import { Component, OnInit, Input, Optional, Inject } from "@angular/core";
import { FromFieldControl } from "../form-field-control";
import { FormGroupDirective } from "@angular/forms";
import {
	FormFieldEvent,
	FormFieldEventType
} from "../form-field-enums";

@Component({
    selector: "tc-number-form-field",
    templateUrl: "./number-form-field.component.html",
    styleUrls: ["./number-form-field.component.scss"],
    standalone: false
})
export class NumberFormFieldComponent extends FromFieldControl
	implements OnInit {
	@Input() step = 0.1;
	@Input() minValue: number;
	@Input() maxValue: number;
	@Input() voidValidImage = false;

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	ngOnInit() {
		this._control.valueChanges.subscribe(val => {
			if (val) {
				if (this.minValue) {
					if (val < this.minValue) {
						console.log("setting up min value error");
						this._control.setErrors({
							error:
								"value out of range. Value less then min allowed value"
						});
					}
				}

				if (this.maxValue) {
					if (val > this.maxValue) {
						console.log("setting up max value error");
						this._control.setErrors({
							error:
								"value out of range. Value greater then max allowed value"
						});
					}
				}
			} else {
				this._control.setErrors(null);
			}

			if (!this.required) {
				this._control.valueChanges.subscribe(value => {
					console.log(value);
					this.event.emit(<FormFieldEvent>{
						type: FormFieldEventType.INPUT_CHANGED
					});
				});
			}
		});
	}

	get __hasError() {
		return this.__control.touched && !this.valid && this.__control.invalid;
	}

	get imageUrl() {
		return this.valid && this.validImage ? (this.voidValidImage ? "" : this.validImage) : this.invalidImage;
	}

	get showImage() {
		return (this.valid && this.validImage) || this.__hasError;
	}
}
